import { TrackingEventTypes } from '../domain/models';
import { isObject } from '@/shared/application/services/isObject';

export const trackingEventConverter = (value: TrackingEventTypes): string | null => {
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) return value.join(' | ');
  if (isObject(value)) return JSON.stringify(value);
  return null;
};
